import { Editor } from "primereact/editor";

interface TextEditorProps {
  placeholder: string;
  onTextChange: (e: any) => void;
  value: any;
}

const TextEditor = ({ placeholder, onTextChange, value }: TextEditorProps) => {
  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
      </span>
    );
  };

  return (
    <Editor
      value={value}
      placeholder={placeholder}
      onTextChange={onTextChange}
      headerTemplate={renderHeader()}
      style={{ height: "200px", width: "auto"}}
    />
  );
};

export default TextEditor;
